export default "__VITE_ASSET__GOiwsIeX__"